// NL
export const paintingDefaultNL = {
  id: '278b223f-86cb-4061-8dda-628d47037b75',
  identifier: 'painting-default',
}
